export default __webpack_public_path__ + "static/panel-anatomy-dark-3ea1260adf950394efc7b43027289ec5b6c361f70a1de34d8558359f04ab06a0.png";